export default __webpack_public_path__ + "static/media/angular.88522df8.png";